import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigModule, ProductSearchAdapter } from '@spartacus/core';
import { ComponentsModule } from './components/components.module';
import { CustomProductIntroComponent } from './components/custom-product-intro/custom-product-intro.component';
import { CustomCxAddToCartComponent } from './components/custom-cx-add-to-cart/custom-cx-add-to-cart.component';
import { CustomOccProductSearch } from './CustomOccProductSearch';
import { CustomProductImagesComponent } from './components/custom-product-images/custom-product-images.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductIntroComponent: {
          component: CustomProductIntroComponent,
        },
        ProductSummaryComponent: {
          component: '',
        },
        ProductAddToCartComponent: {
          component: CustomCxAddToCartComponent,
        },
        ProductImagesComponent: {
          component: CustomProductImagesComponent,
        }
      },
    }),
  ],
  providers: [
    {
      provide: ProductSearchAdapter,
      useClass: CustomOccProductSearch,
    },
  ],
})
export class CustomPdpModule {}
